<template>
  <MeasurementList :measurements="readingStatistics" customClass="measurement-statistics-wrapper" />
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import MeasurementList from '@/components/devicePopover/content/measurements/layouts/MeasurementList.vue'
import { NAMESPACES } from '@/store'
import { DEVICE_GETTERS } from '@/store/devices'
import {
  measurementStatistics,
  MeasurementType,
  measurementTypesKey
} from '@/services/device-measurements'
import { getPopoverMeasurementData } from '@/helpers/widgets/helper'
import type { PopoverMeasurementDataResult } from '@/helpers/widgets/helper'
import type { MeasurementStats } from '@/components/devicePopover/types'

export default defineComponent({
  name: 'MeasurementStatistics',
  components: {
    MeasurementList
  },
  props: {
    deviceId: { type: String, default: '' },
    selectedParameter: {
      type: Number as PropType<MeasurementType>
    },
    measurementStatisticsReadings: {
      type: Object as PropType<MeasurementStats>
    }
  },
  computed: {
    deviceType(): string {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_DEVICE_TYPE_BY_DEVICE_ID}`
      ](this.deviceId)
    },
    readingStatistics(): PopoverMeasurementDataResult[] {
      const statistics = measurementStatistics[this.selectedParameter]

      if (statistics) {
        return [
          this.getPopoverMeasurementStatistic(
            measurementTypesKey[statistics.minimum],
            this.$t('widget.currentReadings.minimum')
          ),
          this.getPopoverMeasurementStatistic(
            measurementTypesKey[statistics.maximum],
            this.$t('widget.currentReadings.maximum')
          ),
          this.getPopoverMeasurementStatistic(
            measurementTypesKey[statistics.average],
            this.$t('widget.currentReadings.average')
          ),
          this.getPopoverMeasurementStatistic(
            measurementTypesKey[statistics.twa],
            this.$t('widget.currentReadings.twa')
          )
        ]
      }

      return []
    }
  },
  methods: {
    getPopoverMeasurementStatistic(
      measurementName: string,
      label: string
    ): PopoverMeasurementDataResult {
      return getPopoverMeasurementData(
        this.$t.bind(this),
        {
          measurementName,
          deviceType: this.deviceType,
          readings: this.measurementStatisticsReadings
        },
        {
          label,
          customClass: 'small-size bolded-reading grey-empty-reading'
        }
      )
    }
  }
})
</script>
